// extracted by mini-css-extract-plugin
export default {"title":"Title_title__ugKfF","center":"Title_center__rOTH-","white":"Title_white__L6RNa","line":"Title_line__nkp8Z","yellow":"Title_yellow__j7AFS"};